import React from 'react';
import {currencyFormat} from '../../../../utils/functions/Functions';
import SaveButton from '../../../../components/SaveButton/SaveButton';
import {checkIfIncomePageIsValid} from '../../../../validation/FormValidation';
import {updateIncomeEditMode} from '../../../../redux/app-state-slice';
import IncomeInfoSection from '../../PrequalForm/IncomeInfoSection/IncomeInfoSection';
import {ToolTip} from '../../../../components/ToolTip/ToolTip';
import InfoCircleIcon from '../../../../assets/icons/info-circle-light-blue.svg';

function IncomeInfoReview({customerData, dispatch, appConfig}) {
  return (
    <>
      {!customerData.cardEditFlags.incomeEditMode.value && (
        <>
          <div
            className={`prequal--web--review-page-padding-20 ${
              customerData.isDealerHostApplication.value ? 'prequal--wc--review-page-item-container' : ''
            }`}
          >
            <label className='prequal--web--label-fomo'>Gross Annual Income&nbsp;</label>
            {!customerData.isDealerHostApplication.value && (
              <span className='prequal--web--review--popover-container'>
                <ToolTip
                  content={
                    <p>
                      Your gross yearly income should account for any recent changes to your job status. It may include part-time work and
                      alternative sources of income.
                      <br />
                      <br />
                      You don&apos;t have to include alimony, child support, or separate maintenance payments if you don&apos;t want us to
                      consider it.
                    </p>
                  }
                  position='top'
                  tooltipIcon={InfoCircleIcon}
                  header='Gross Yearly Income'
                />
              </span>
            )}
            <p className='prequal--web--display-text-fomo'>
              <span>{customerData.income.value ? currencyFormat(customerData.income.value) : ''}</span>
            </p>
          </div>
        </>
      )}
      {customerData.cardEditFlags.incomeEditMode.value && (
        <>
          <div
            className={`prequal--web--review-page-padding-20 ${
              customerData.isDealerHostApplication.value ? 'prequal--wc--review-page-item-container' : ''
            }`}
          />
          <IncomeInfoSection dispatch={dispatch} customerData={customerData} appConfig={appConfig} />
          <SaveButton
            onClickHandler={() => (checkIfIncomePageIsValid(customerData) ? dispatch(updateIncomeEditMode(false)) : null)}
            isFieldValid={checkIfIncomePageIsValid(customerData)}
          />
        </>
      )}
    </>
  );
}

export default IncomeInfoReview;
